import { FC, InputHTMLAttributes } from 'react';
import { InputText } from './styles';

export const Input: FC<InputHTMLAttributes<HTMLInputElement>> = props => {
	return <InputText {...props} autoComplete="off" $textIndent="15px" />;
};
